import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PARAM_LABEL_INTERVENTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';

@Component({
	selector: 'app-no-data-available',
	templateUrl: './no-data-available.component.html',
	styleUrls: ['./no-data-available.component.scss']
})
export class NoDataAvailableComponent implements OnInit {
	@Input() weekNumber: number;
	@Input() isReportByMonth: boolean = false;

	displayText = 'Pas de données disponible pour la semaine sélectionnée.';

	constructor(private router: Router, private facade: FacadeService) {}

	ngOnInit(): void {
		const prestaLabel = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		if (this.router.url.includes('/planning')) {
			this.displayText = `Pas de ${prestaLabel} pour la semaine sélectionnée.`;
		}

		if (this.isReportByMonth) {
			this.displayText = `Pas de données pour le mois sélectionné.`;
		}

	}
}
